import {notChildren, onMouseUp} from "./utilities";
import * as $ from 'jquery'
import * as DragSelect from 'dragselect'

export const selectableInit = (svg, onSelected, changeHighlighModalPosition,
                       toggleActiveHighlight, activeHighlight, setOpenAddNote,
                       setSearchResult, clear) => {
  if (clear) $('.ds-selector').remove()
  let ds = new DragSelect({
    selectables: $('.svgWrapper rect')
  })
  let allRects = [].slice.call(svg.selectAll('rect')._groups[0])
  let drag = false
  let pdfReader = document.getElementsByClassName('PdfReader')[0]

  let selectionRect = {
    element			: null,
    previousElement : null,
    currentY		: 0,
    currentX		: 0,
    originX			: 0,
    originY			: 0,
    firstRect       : null,
    firstIndex      : null,
    lastIndex       : null,
    inMouse         : null,
    setElement: (ele) => {
      selectionRect.previousElement = selectionRect.element;
      selectionRect.element = ele;
    },
    getNewAttributes: () => {
      let x = selectionRect.currentX<selectionRect.originX?selectionRect.currentX:selectionRect.originX;
      let y = selectionRect.currentY<selectionRect.originY?selectionRect.currentY:selectionRect.originY;
      let width = Math.ceil(selectionRect.currentX - selectionRect.originX);
      let height = Math.abs(selectionRect.currentY - selectionRect.originY);
      return {
        x       : x,
        y       : y,
        width  	: width,
        height  : height
      };
    },
    getCurrentAttributes: () => {
      let x = +selectionRect.element.x;
      let y = +selectionRect.element.y;
      let width = +selectionRect.element.width;
      let height = +selectionRect.element.height;
      return {
        x1  : x,
        y1	: y,
        x2  : x + width,
        y2  : y + height,
        center: x + width/2,
        width: width
      };
    },
    getCurrentAttributesAsText: () => {
      let attrs = selectionRect.getCurrentAttributes();
      return "x1: " + attrs.x1 + " x2: " + attrs.x2 + " y1: " + attrs.y1 + " y2: " + attrs.y2;
    },
    init: (newX, newY) => {
      let rectElement = {
        'rx': 4,
        'ry': 4,
        'x': 0,
        'y': 0,
        'width': 0,
        'height': 0
      }

      selectionRect.setElement(rectElement);
      selectionRect.originX = newX;
      selectionRect.originY = newY;
      selectionRect.update(newX, newY);
    },
    update: (newX, newY) => {
      selectionRect.currentX = newX;
      selectionRect.currentY = newY;
      let attrs = selectionRect.getNewAttributes()

      selectionRect.element.x = attrs.x
      selectionRect.element.y = attrs.y
      selectionRect.element.width = attrs.width
      selectionRect.element.height = attrs.height
    },
    remove: () => {
      selectionRect.element = null;
      selectionRect.firstRect = null;
      selectionRect.firstIndex = null;
      selectionRect.inMouse = null;
      selectionRect.originX = null;
      selectionRect.originY = null;
    },
    removeSelected: () => {
      let rects = svg.selectAll('rect')._groups[0]
      for (let i=0; i < rects.length; i++) {
        let rect = rects[i]
        if (!rect) continue
        $(rect).removeClass('selected')
      }
      selectionRect.firstRect = null;
      selectionRect.firstIndex = null;
      selectionRect.lastIndex = null;
      selectionRect.inMouse = null;
    },
    stopSelection: () => {
      selectionRect.firstRect = null;
      selectionRect.firstIndex = null;
      selectionRect.lastIndex = null;
      selectionRect.inMouse = null;

      ds.stop();
      ds.start();
    },
    removePrevious: () => {
      if(selectionRect.previousElement) {
        selectionRect.previousElement = null;
      }
    },
    contains: (first, range, curr) => {
      if (selectionRect.firstRect == null) return
      let firstInLine = selectionRect.firstInLine
      let lastInLine = selectionRect.lastInLine

      let limits = curr.x2 >= firstInLine.x1 && curr.x1 <= lastInLine.x2
      let fCondition = curr.x2 <= range.x2 && curr.y1 >= range.y1 && curr.y2 <= range.y2 && curr.y1 >= first.y2 && limits
      let sCondition = curr.x2 <= range.x2 && range.y2 >= curr.y1 && range.y2 <= curr.y2 && curr.y1 >= first.y2 && limits
      return fCondition || sCondition
    },
    containsFirst: (range, curr) => {

      let firstCondition = range.y1 >= curr.y1 && range.y1 <= curr.y2 && curr.x2 <= range.x2 && curr.x1 >= range.x1
      let secondCondition = curr.x2 <= range.x2 && curr.x1 >= range.x1 && curr.y1 >= range.y1 && curr.y2 <= range.y2
      return firstCondition || secondCondition
    },
    inFirstLine: (first, curr) => {
      if(first === null) return
      let firstInLine = selectionRect.firstInLine
      let lastInLine = selectionRect.lastInLine

      return curr.y1 === first.y1 && curr.y2 === first.y2 && curr.x2 >= firstInLine.x1 && curr.x1 <= lastInLine.x2
    },
    inFirstLineContains: (first, curr, range) => {
      let lastInLine = selectionRect.lastInLine

      if (first.y2 <= range.y2) {
        return curr.x1 >= first.x1 && curr.x1 <= lastInLine.x2
      } else {
        return curr.x1 >= first.x1 && curr.x2 <= range.x2
      }
    },
    between: (first, curr, range) => {
      if(first === null) return
      let firstInLine = selectionRect.firstInLine
      let lastInLine = selectionRect.lastInLine

      let fCondition = curr.y1 >= first.y1 && curr.y2 <= range.y2 && curr.x2 >= firstInLine.x1 && curr.x1 <= lastInLine.x2
      return fCondition
    },
    getRectCoords: (clientRect) => {
      return {
        x1: clientRect.x || clientRect.left,
        y1: clientRect.y || clientRect.top,
        x2: clientRect.x ? clientRect.x + clientRect.width : clientRect.left + clientRect.width,
        y2: clientRect.y ? clientRect.y + clientRect.height : clientRect.top + clientRect.height,
        width: Math.ceil(clientRect.width),
        center: clientRect.x ? clientRect.x + clientRect.width/2 : clientRect.left + clientRect.width/2
      }
    }
  };

  const dragStart = (e) => {
    selectionRect.remove();
    selectionRect.removeSelected();
    selectionRect.removePrevious();
    drag = false

    let p = [e.clientX, e.clientY]
    selectionRect.init(p[0], p[1]);
  }

  const contains = (item, x, y) => {
    const rectContains = (r, x, y) => {
      let top = r.top;
      let left = r.left;
      let bottom = top + r.height;
      let right = left + r.width;
      return top <= y && left <= x && bottom > y && right > x;
    }

    let rect = item.getBoundingClientRect();

    if (!rectContains(rect, x, y)) {
      return false;
    }

    let rects = item.getClientRects();
    for (let i = 0, len = rects.length; i < len; i++) {
      if (rectContains(rects[i], x, y)) {
        return true;
      }
    }
    return false;
  }

  const getLimits = (rects, first, e) => {
    let smaller = first
    let biggest = first

    for (let i=0; i < rects.length; i++) {
      let rect = rects[i]
      let index = allRects.indexOf(rect)
      if (index <= first) {
        smaller = index
      }
      if (index >= first) {
        biggest = index
      }
      if (contains(rect, e.clientX, e.clientY)) {
        selectionRect.inMouse = rect
      }
    }

    if (smaller < first) {
      smaller = parseInt(selectionRect.inMouse.dataset.wordIndex, 10)
      biggest = first
    }

    if (smaller > biggest) {
      let tempBiggest = biggest
      biggest = smaller
      smaller = tempBiggest
    }

    return {
      smaller: smaller,
      biggest: biggest
    }
  }

  const dragMove = (e) => {
    if (!selectionRect.originX && !selectionRect.originY) return
    drag = true

    let p = [e.clientX, e.clientY]
    selectionRect.update(p[0], p[1]);
    let rects = ds.getSelection()

    if (selectionRect.firstIndex === null && rects.length > 0) {
      let rect = rects[0]
      let index = allRects.indexOf(rect)
      selectionRect.firstIndex = index
      selectionRect.lastIndex = index
    }
    if (selectionRect.firstIndex === null) return

    let limits = getLimits(rects, selectionRect.firstIndex, e)

    let smaller = limits.smaller
    let biggest = limits.biggest
    selectionRect.lastIndex = biggest

    $(allRects).removeClass('selected')
    for (let i = smaller; i <= biggest; i++) {
      $(allRects[i]).addClass('selected')
    }
  }

  const dragEnd = (e) => {
    let rects = ds.getSelection()
/*    if (rects.length === 1 && $(rects[0]).attr('data-offset')) {
      selectionRect.remove();
      selectionRect.removeSelected()
      drag = false
      return
    } else*/
    if ((drag && selectionRect.firstIndex && rects.length > 0) /*|| $(target).attr('data-offset')*/) {
      mouseInit(e)
      selectionRect.remove();
      selectionRect.stopSelection()
    } else {
      selectionRect.remove();
      selectionRect.removeSelected()
    }
    drag = false
  }

  const mouseInit = (e) => {
    let target = e.target
    const nav = document.getElementById('viewer')
    const markTag = document.getElementsByClassName('mark')
    const popupTag = document.getElementById('HighlightModal__wrapper')
    let flags = []
    let marks = []
    let popup = []
    notChildren(flags, target, nav.children)
    notChildren(marks, target, markTag)
    notChildren(popup, target, popupTag.children)

    if (!(marks.indexOf(false) > -1) && !(popup.indexOf(false) > -1) &&
      e.target.tagName.toLowerCase() !== 'a') {
      onSelected(svg.selectAll('.selected'), '', '' , e)
    }
  }

  pdfReader.addEventListener('mousedown', (e) => dragStart(e))
  pdfReader.addEventListener('mousemove', (e) => dragMove(e))
  pdfReader.addEventListener('mouseup', (e) => dragEnd(e))
}

export const parseXmlToPage = (xml, svg, onSelected, changeHighlighModalPosition,
                               toggleActiveHighlight, activeHighlight, setOpenAddNote,
                               setSearchResult, clear) => {
  let g = svg.append('g')
          .attr('class', 'state')

  xml.children.forEach(child => {
    if (child.name === 'text') {
      let rectIndex = 0
      child.children.forEach((line, lineIndex) => {
        if (line.attributes && line.attributes.a) {
          let y = line.attributes.a.split(',')[1]
          let h = line.attributes.a.split(',')[3]

          line.children.forEach((word, wordIndex) => {
            let next = false
            if((wordIndex+1) <= line.children.length) {
              next = line.children[wordIndex+1]
            }
            if (word.value !== '' && word.attributes && word.attributes.a) {
              let coords = word.attributes.a.split(',')
              let width = coords[1]
              if (next && next.attributes && next.attributes.a) {
                let nextCoords = next.attributes.a.split(',')
                let spaces = parseInt(nextCoords[0], 10) - (parseInt(coords[0], 10) + parseInt(coords[1], 10))
                let mWidth = parseInt(width, 10) + spaces
                if (mWidth > 0) {
                  width = mWidth
                }
              }

              let rect = g.append('rect').attr('x', coords[0])
                .attr('y', y)
                .attr('width', width)
                .attr('height', h)
                .attr('fill', 'transparent')
                .attr('data-text', word.value)
                .attr('data-coords', word.attributes.a)
                .attr('line-index', lineIndex)
                .attr('data-word-index', rectIndex)
              rectIndex++
              if (wordIndex === line.children.length-1) {
                rect.attr('lastInLine', '1')
              } else if (wordIndex === 0) {
                rect.attr('firstInLine', '1')
              }
            }
          })
        }
      })
    }
  })

  selectableInit(svg, onSelected, changeHighlighModalPosition,
    toggleActiveHighlight, activeHighlight, setOpenAddNote,
    setSearchResult, clear)
}

const getClearStr = (textStr) => {
  if (!textStr) return ''
  return textStr
    .replace(/<\/?[^>]+(>|$)/g, " ")
    .replace(/\n/g, ' ')
    .replace(/\s\s+/g, ' ')
}

export const createTextFromRects = (rects) => {
  let text = ''
  let offs = 0

  for (let i = 0; i < rects.length; i++) {
    let rect = rects[i]
    let rectText = $(rect).attr('data-text')
    offs += rectText.length
    text += rectText + ' '
  }
  text = text.trim()

  return {
    text: text,
    offs: offs
  }
}

export const getTextPosition = (xml, firstWord, lastWord, rects) => {
  let textStr = xml.substring(
    xml.lastIndexOf("<text>") + 6,
    xml.lastIndexOf("</text>")
  );
  let textFromRects = createTextFromRects(rects)
  let splitByFirstWord = textStr.split(firstWord + '">' + $(rects[0]).attr('data-text'))
  splitByFirstWord[1] = $(rects[0]).attr('data-text') + splitByFirstWord[1]

  let str = splitByFirstWord[0] + '">'
  str = getClearStr(str)

  let fOffs = str.length
  let lOffs = 0
  let text = ''

  if (firstWord === lastWord) {
    lOffs = fOffs + textFromRects.offs
    text = textFromRects.text
  } else {
    let secondPart = splitByFirstWord[1]
    secondPart = secondPart.split(lastWord)
    secondPart = getClearStr(secondPart[0])
    let lastPart = $(rects[rects.length-1]).attr('data-text')
    let lastPartOffs = lastPart.length

    lOffs = fOffs + secondPart.length + lastPartOffs
    text = secondPart + lastPart
  }

  return {
    offs: fOffs,
    over: lOffs - 1,
    text: text
  }
}

const getWord = (rects, highlightText, indexs, offset, rectsIndex = 0, wordIndex = 0, firstRect = 0) => {
  let textOffset = 0
  for (let i=rectsIndex; i < rects.length; i++) {
    let rect = rects[i]
    let text = rect.getAttribute('data-text')
    textOffset += text.length

    if (highlightText[wordIndex] && highlightText[wordIndex].trim() === $(rect).attr('data-text') && textOffset >= offset - 50) {
      if (highlightText.length === 1) {
        indexs.first = i
        indexs.last = i
        break
      } else {
        getNextWord(rects, highlightText, i+1, wordIndex+1, indexs)
        if (indexs.last) {
          indexs.first = i
          break
        }
      }
    }
  }
}

const getNextWord = (rects, highlightText, i, wordIndex, indexs) => {
  if ($(rects[i]).attr('data-text') === highlightText[wordIndex].trim()) {
    if ((highlightText.length-1) === wordIndex) {
      indexs.last = i
    } else if ((highlightText.length-2) === wordIndex) {
      indexs.last = i + 1
    } else {
      getNextWord(rects, highlightText, i+1, wordIndex+1, indexs)
    }
  }
}

export const isEqual = (value, other) => {
  let type = Object.prototype.toString.call(value);

  if (type !== Object.prototype.toString.call(other)) return false

  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false

  let valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
  let otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
  if (valueLen !== otherLen) return false;

  const compare = (item1, item2) => {
    let itemType = Object.prototype.toString.call(item1);

    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false;
    }
    else {
      if (itemType !== Object.prototype.toString.call(item2)) return false;
      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) return false;
      } else {
        if (item1 !== item2) return false;
      }
    }
  };

  if (type === '[object Array]') {
    for (let i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false;
    }
  } else {
    for (let key in value) {
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) return false;
      }
    }
  }

  return true
}

export const setRect = (rect, color, offset, over) => {
  if (rect.dataset.offset) {
    let newRect = rect.cloneNode(true)
    rect.parentNode.insertBefore(newRect, rect)
    rect = newRect
  }
  $(rect).removeAttr('class')
  $(rect).addClass(color)
  $(rect).attr('data-offset', offset)
  $(rect).attr('data-over', over)

  return rect
}

const getUniqArray = (a) => {
  let arr =  Array.from(a)
  return arr.filter((item, pos, self) => {
    if (pos > 0) {
      let prevItem = self[pos-1]
      let prevCoords = prevItem.dataset.coords
      let coords = item.dataset.coords
      if (prevCoords === coords) return false
    }
    return true
  })
}

let pattern = /([’‘,.*\s\n\-+@%'"“”©®^«»?!:;…–§{}()|[\]\\^$])/g

export const addHighlightInPage = (xmlText, offset, over, svg, color, text) => {
  let textStr = xmlText.substring(
    xmlText.lastIndexOf("<text>") + 6,
    xmlText.lastIndexOf("</text>")
  );
  let str = getClearStr(textStr)

  let rectOffset = str.slice(0, offset).replace(/\n/g, '')
    .replace(/\s/g, '').length

  str = str.substring(offset, over+2)

  let highlightText = str.split(pattern)
    .filter(item => item.trim().length > 0)
  let hText = str
  let rects = svg.selectAll('rect')._groups[0]
  rects = getUniqArray(rects)
  let indexs = {}

  text = getClearStr(text)
  text = text.split(pattern)
    .filter(item => item.trim().length > 0)

  let checkOffset = isEqual(highlightText, text)

  getWord(rects, checkOffset ? highlightText : text, indexs, rectOffset)

  hText = hText.trim()
  let chars = {
    first: hText.charAt(0),
    last: hText.charAt(hText.length-1)
  }

  let selectedRects = []

  for (let i=0; i < rects.length; i++) {
    let rect = rects[i]
    if (i === indexs.first) {
      let prev = rects[i-1]
      if (prev && prev.dataset && prev.dataset.text === chars.first) {
        prev = setRect(prev, color, offset, over)
        selectedRects.push(prev)
      }
    } else if (i === indexs.last) {
      let next = rects[i+1]
      if (next && next.dataset && next.dataset.text === chars.last) {
        next = setRect(next, color, offset, over)
        selectedRects.push(next)
      }
    }
    if (i >= indexs.first && i <= indexs.last) {
      rect = setRect(rect, color, offset, over)
      selectedRects.push(rect)
    }
  }
  return selectedRects
}

export const addNoteInPage = (xml, num, offset, over, svg, noteText, setEditNoteText, onSelected,
                              changeHighlighModalPosition, toggleActiveHighlight, activeHighlight, setOpenAddNote, textInPage, eventEmmiter, note) => {
 let page = $('[data-page-number="'+num+'"]')[0]

  let textStr = xml.substring(
    xml.lastIndexOf("<text>") + 6,
    xml.lastIndexOf("</text>")
  );
  let str = getClearStr(textStr)

  let rectOffset = str.slice(0, offset).replace(/\n/g, '')
    .replace(/\s/g, '').length

  let text = str.substring(offset, over+2)

  let highlightText = text.split(pattern)
    .filter(item => item.trim().length > 0)

  textInPage = getClearStr(textInPage)
  textInPage = textInPage.split(pattern)
    .filter(item => item.trim().length > 0)

  let checkOffset = isEqual(highlightText, textInPage)

  let rects = svg.selectAll('rect')._groups[0]
  rects = getUniqArray(rects)
  let indexs = {}
  getWord(rects, checkOffset ? highlightText : textInPage, indexs, rectOffset)

  let firstWord
  for (let i=0; i < rects.length; i++) {
    let rect = rects[i]
    if (i === indexs.first) {
      firstWord = rect
    }
  }

  if (!firstWord) return
  let offsetTop = firstWord.getBoundingClientRect().top - page.getBoundingClientRect().top
  let h = firstWord.getBoundingClientRect().height
  offsetTop = offsetTop + h/2 - 11.5

  const onClick = (e) => {
    setEditNoteText(noteText)
    onSelected({begin: offset, end: over}, text, '', e, $(firstWord).attr('data-coords'))
    let openClass = 'openEditNote'
    eventEmmiter.emit('markClicked', note)
    onMouseUp(e, changeHighlighModalPosition, toggleActiveHighlight, activeHighlight, onSelected, setOpenAddNote, openClass, true)
  }

  let link = document.createElement('a')
  link.classList.add('mark')
  link.dataset.begin = offset
  link.dataset.end = over
  link.dataset.noteText = noteText

  let svgWidth = document.getElementsByClassName('pngWrapper')[0].style.width
  svgWidth = parseInt(svgWidth.slice(0, -2), 10)

  let offsetLeft = svgWidth
  let markOffset = getNotePosition({top: offsetTop, left: offsetLeft})
  $('[data-page-number="'+num+'"] .svgWrapper').append(link)
  link.style.top = markOffset.top + 'px'
  link.style.left = markOffset.left + 'px'
  link.addEventListener('click', (e) => onClick(e))
}

export const getNotePosition = (offs, level = 0) => {
  let startOffs = offs
  let marks = $('.mark')
  for (let i=0; i < marks.length; i++) {
    let mark = marks[i]
    let markTop = parseInt($(mark).css('top').slice(0, -2), 10)
    let markLeft = parseInt($(mark).css('left').slice(0, -2), 10)

    if (Math.floor(markTop) === Math.floor(offs.top) &&
        Math.floor(markLeft) === Math.floor(offs.left)) {
      level++
      if (level % 2 !== 0) {
        offs.top = markTop + 5
        offs.left = markLeft + 5
      }
      if (startOffs !== offs) offs = getNotePosition(offs, level)
      break
    }
  }
  return offs
}

export const getPdtPosition = (str) => {
  if (!str) return ''
  let page = ''
  if (str.indexOf('#pdfloc') > -1) {
    page = str.split(',')[1]
    if(!page) return ''
    page = page.indexOf(')') > -1 ? page.slice(0, -1) : page
  } else if (str.indexOf('page=') > -1) {
    page = str.split('page=')[1]
    if (!page) return ''
    page = page.split('&')
    page = page[0] ? page[0] : page
  }
  return parseInt(page, 10) + 1
}

export const getOffset = (str) => {
  return str.substring(
    str.lastIndexOf("&offs=") + 6,
    str.lastIndexOf("##")
  )
}

export const getOver = (str) => {
  return str.substring(
    str.lastIndexOf("&over=") + 6,
    str.lastIndexOf("##")
  )
}



// WEBPACK FOOTER //
// ./src/utilities/pdfUtilities.js